import React from "react";

const ResultTitle = (props) => {
  return (
    <div className="row" style={{ marginTop: "10px" }}>
      <div className="col-sm-12 col-md-12">
        <React.Fragment>
          <h4>
            Search result for :{" "}
            <small>
              <span>{props.title}</span>
            </small>
          </h4>
        </React.Fragment>
      </div>
    </div>
  );
};
export default ResultTitle;
